// extracted by mini-css-extract-plugin
module.exports = {"table":"table__2KoFR","table-header":"table-header__1ANqF","table-body":"table-body__IIVXq","table-row":"table-row__P78N2","overlay":"overlay__3EhmI","loader":"loader__32YbS"};